module.exports = __webpack_public_path__ + "static/img/logo_background.d8ae93a.jpg";